import React from "react";
import HeroImage from "../assets/Dp.jpg";
import { MdDownload, MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-scroll";
import SocialLinks from "../components/SocialLinks";

const Home = () => {
  return (
    <div
      name="home"
      className="h-min-screen w-full bg-slate-800 p-11"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col justify-center h-full px-4 md:flex-row pt-11">
        <div className="pt-11 md:mr-11">
          <img
            src={HeroImage}
            alt="my profile"
            className="rounded-2xl mx-auto w-2/3 md:w-full"
          />
          <SocialLinks />
        </div>

        <div className="flex flex-col justify-center h-full">
          <h2 className="mt-10 text-4xl sm:text-7xl font-bold text-teal-400">
            I'm a Game Designer, Developer
          </h2>
          <p className="text-gray-400 py-4 max-w-md">
            I am a passionate and versatile Game Designer/Developer with <span className="font-extrabold">1.5 years</span> of experience in the hypercasual game industry. I have independently handled projects from
            concept to release, designing <span className="font-extrabold">50+ game concepts</span> and developing <span className="font-extrabold">6 prototypes</span> published on
            <span className="font-extrabold"> Google Play</span>. I have achieved strong performance metrics, <span className="font-extrabold">reaching 1000+ D1 PT</span> and <span className="font-extrabold">under 60c CPI</span> in challenging markets. Collaborating with top publishers like <a href="https://supersonic.com/" target="blank" className="font-extrabold underline">Supersonic Studios</a>, <a href="https://www.homagames.com/" target="blank" className="font-extrabold underline">HOMA Games </a>, I have gained valuable insights into market trends, player engagement, and rapid
            prototyping. My expertise in <span className="font-extrabold">Unity Engine</span> game development, combined with a strong focus on
            creative problem-solving and iterative design, allows me to craft engaging and polished gameplay
            experiences.
          </p>

          <div>
            <Link
              to="portfolio"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
              </span>
            </Link>
          </div>
          <div>
            <a href="https://drive.google.com/file/d/16tm2FFYdYfbwMTQ1qMvl0tahuNJBtHFl/view?usp=sharing"
              target="blank"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              Download CV
              <span>
                <MdDownload size={25} className="ml-1" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
